import React from "react";

function Input(props) {
    return (
        <div>
            {props.label ? (
                <label
                    htmlFor="email"
                    className="block text-sm font-medium leading-6 text-gray-900"
                >
                    {props.label}
                </label>
            ) : null}
            <div className="mt-2">
                <input
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    {...props}
                />
            </div>
        </div>
    );
}
export default Input;
